import * as R from 'ramda';
import React from 'react';
// components
import { TextComponent } from '../text';
// features
import PC from '../../features/permission/role-permission';
import { AuthWrapper } from '../../features/permission/index';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// ui
import { Flex } from '../../ui';
//////////////////////////////////////////////////

const borderGrayColor = G.getTheme('colors.borderGray');
const mainDarkColor = G.getTheme('colors.dark.mainDark');
const transparentGreyColor = G.getTheme('colors.transparentGrey');

const renderRow = ({ load, actions, actionWidth, fromDetails, actionNames, withoutActions, handleActionClick }) => (
  actionNames.map((actionName, i) => {
    const data = actions[actionName];

    if (R.isNil(data)) return null;

    if (R.and(
      R.equals(actionName, GC.OPEN_IN_ROUTE_BUILDER_ACTION),
      R.includes(G.getWindowLocationPathname(), [GC.ROUTE_PATH_ROUTE_BUILDER]),
    )) return null;

    let displayedValue = G.getDisplayedValueFromObject(data);
    let permissions = G.getPropFromObject('permissions', data);

    if (G.isAllTrue(
      G.isNotNilAndNotEmpty(load),
      G.isNilOrEmpty(R.path([GC.FIELD_ROUTE_GUID], load)),
      R.equals(actionName, GC.OPEN_IN_ROUTE_BUILDER_ACTION),
    )) {
      displayedValue = G.getWindowLocale('titles:go-to-load-planner', 'Go To Load Planner');
    } else if (G.isAllTrue(
      G.isNotNilAndNotEmpty(load),
      G.isFalse(G.getPropFromObject(GC.FIELD_MARGIN_VIOLATION_APPROVED, load)),
      R.or(R.equals(actionName, GC.DISPATCH_LOAD_ACTION), R.equals(actionName, GC.RE_DISPATCH_LOAD_ACTION)),
      G.isAnyTrue(
        G.isTrue(G.getPropFromObject(GC.FIELD_MAX_PAY_VIOLATED, load)),
        G.isTrue(G.getPropFromObject(GC.FIELD_MIN_MARGIN_VIOLATED, load)),
        G.isTrue(G.getPropFromObject(GC.FIELD_CRITICAL_MARGIN_VIOLATED, load)),
      ),
    )) {
      permissions = [PC.MARGIN_VIOLATION_APPROVAL_EXECUTE];
      displayedValue = G.getWindowLocale('titles:approve', 'Approve');
    }

    const componentProps = {
      mr: '8px',
      p: '4px 8px',
      fontSize: 11,
      height: '100%',
      fontWeight: 600,
      display: 'block',
      withEllipsis: true,
      textAlign: 'center',
      borderRadius: '5px',
      color: mainDarkColor,
      title: displayedValue,
      width: R.or(actionWidth, 150),
      border: `1px solid ${borderGrayColor}`,
      bg: G.ifElse(fromDetails, null, transparentGreyColor),
    };

    if (withoutActions) {
      return (
        <TextComponent key={i} {...componentProps}>
          {displayedValue}
        </TextComponent>
      );
    }

    return (
      <AuthWrapper key={i} has={permissions} notHas={data.notHasPermissions}>
        <TextComponent
          {...componentProps}
          onClick={() => handleActionClick(actionName)}
          cursor={G.ifElse(R.not(withoutActions), 'pointer')}
        >
          {displayedValue}
        </TextComponent>
      </AuthWrapper>
    );
  })
);

export const LoadStatusActions = (props) => {
  const {
    data,
    load,
    loadType,
    withTitle,
    actionWidth,
    fromDetails,
    withoutActions,
    handleActionClick,
  } = props;

  if (G.isNilOrEmpty(data)) return null;

  const { firstRow, secondRow } = data;
  const actions = G.getLoadStatusActions(loadType, data[GC.FIELD_STATUS]);

  return (
    <Flex flexDirection='column'>
      {
        G.isTrue(withTitle) &&
        <Flex mb={10} fontWeight={600}>{G.getWindowLocale('titles:actions', 'Actions')}</Flex>
      }
      {
        G.isNotNilAndNotEmpty(firstRow) &&
        <Flex width='100%' height={20} alignItems='flex-start'>
          {
            renderRow({
              load,
              actions,
              actionWidth,
              fromDetails,
              withoutActions,
              handleActionClick,
              actionNames: firstRow,
            })
          }
        </Flex>
      }
      {
        G.isNotNilAndNotEmpty(secondRow) &&
        <Flex mt='8px' height={20} width='100%' alignItems='flex-start'>
          {
            renderRow({
              load,
              actions,
              actionWidth,
              fromDetails,
              withoutActions,
              handleActionClick,
              actionNames: secondRow,
            })
          }
        </Flex>
      }
    </Flex>
  );
};
